// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/a5c7c3c73c15b961158c.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"efc2e29c4df70132b3a3","125":"40487a18e04d39ff9d07","126":"44722c13c14030d8010d"}[chunkId] + ".chunk.js";
};